import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Linkedin, Sun, Moon } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Education", href: "#education" },
  { label: "Contact", href: "#contact" },
];

export const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav({ theme, onToggle }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-forest/85 backdrop-blur-md border-treeline" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("#top")}
          className="font-display text-lg tracking-tight text-cream hover:text-lime transition-colors duration-300"
        >
          S<span className="text-lime">.</span>Tadesse
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l, i) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => scrollTo(l.href)}
              className="group font-mono text-xs uppercase tracking-[0.2em] text-sage hover:text-cream transition-colors duration-300"
            >
              <span className="text-lime/60 mr-1">0{i + 1}</span> {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <button
            data-testid="theme-toggle-button"
            onClick={onToggle}
            aria-label="Toggle light and dark theme"
            className="text-sage hover:text-lime transition-colors duration-300"
          >
            {theme === "light" ? <Moon size={16} /> : <Sun size={16} />}
          </button>
          <div className="hidden md:flex items-center gap-4">
            <a
              data-testid="nav-linkedin-link"
              href="https://www.linkedin.com/in/sarron-tadesse-114aab1b9"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn profile"
              className="text-sage hover:text-lime transition-colors duration-300"
            >
              <Linkedin size={16} />
            </a>
            <a
              data-testid="nav-resume-button"
              href="/assets/Sarron_Tadesse_Resume.pdf"
              download
              className="font-mono text-xs uppercase tracking-[0.2em] border border-lime/50 text-lime px-4 py-2 hover:bg-lime hover:text-forest transition-colors duration-300"
            >
              Resume
            </a>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
